// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { RtToastService } from 'rt-toasts';
import {
  CreateStorageItem,
  CreateStorageItemFail,
  CreateStorageItemSuccess,
  CreateStorageLocation,
  CreateStorageLocationFail,
  CreateStorageLocationSuccess,
  GetAllStorageLocation,
  GetGoods,
  markFolders,
  MoveStorageItem,
  MoveStorageItemFail,
  MoveStorageItemSuccess,
  SelectGoods,
  StorageLocationTreeModel,
  StorageService,
  UpdateStorageItem,
  UpdateStorageItemFail,
  UpdateStorageItemSuccess,
  UpdateStorageLocation, UpdateStorageLocationFail,
  UpdateStorageLocationSuccess
} from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import { GetStorageLocation } from './storage-location.actions';
import { STORAGE_LOCATION_STATE_DEFAULT, StorageLocationStateModel } from './storage-location.model';


@State({ name: 'Storage', defaults: STORAGE_LOCATION_STATE_DEFAULT })
@Injectable()
export class StorageState {

  constructor(private service: StorageService, private toastService: RtToastService) {
  }

  @Selector()
  static currentItem(state: StorageLocationStateModel): StorageLocationStateModel['currentItem'] {
    return state.currentItem;
  }

  @Selector()
  static storageLocations(state: StorageLocationStateModel): StorageLocationTreeModel {
    return state.storageLocations;
  }

  @Selector()
  static currentLocationId(state: StorageLocationStateModel): StorageLocationStateModel['currentLocationId'] {
    return state.currentLocationId;
  }

  @Selector([StorageState])
  static currentChildren(
    state: StorageLocationStateModel
  ): StorageLocationTreeModel['childrenFolders'] {
    const goods = state.goods;
    const currentFolders = cloneDeep(state.storageLocations);
    const allLocation = cloneDeep(state.allStorageLocations);
    if (!currentFolders) {
      return [];
    }

    return markFolders(state.currentLocationId, allLocation, goods, currentFolders.childrenFolders);
  }


  @Selector()
  static goods(state: StorageLocationStateModel): StorageLocationStateModel['goods'] {
    return state.goods;
  }

  @Selector()
  static loadStorageLocationsStatus(state: StorageLocationStateModel): StorageLocationStateModel['loadStorageLocationsStatus'] {
    return state.loadStorageLocationsStatus;
  }

  @Action(GetStorageLocation)
  getStorageLocation(ctx: StateContext<StorageLocationStateModel>, { folderId }: GetStorageLocation): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getStorageLocations(folderId)
      .subscribe({
        next: (storageLocations) => {
          ctx.patchState({
            storageLocations,
            currentLocationId: folderId,
            currentItem: null,
            loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: (error) => {
          ctx.patchState({
            loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
          });
          console.error('Error loading storage locations', error);
        }
      });
  }


  @Action(GetGoods)
  getGoods(ctx: StateContext<StorageLocationStateModel>, { search, onlyUsed }: GetGoods): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getGoods(search, onlyUsed)
      .subscribe({
        next: (goods) => {


          ctx.patchState({
            goods,
            loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: (error) => {
          ctx.patchState({
            loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
          });
          console.error('Error loading goods', error);
        }
      });
  }

  @Action(GetAllStorageLocation)
  getAllStorageLocation(ctx: StateContext<StorageLocationStateModel>): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getAllStorageLocations()
      .subscribe({
        next: (allStorageLocations) => {
          ctx.patchState({
            allStorageLocations,
            loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: (error) => {
          ctx.patchState({
            loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
          });
          console.error('Error loading storage locations', error);
          this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося завантажити список' });
          console.error('`CreateStorageItemFail`: Не вдалося завантажити список', error);
        }
      });
  }

  @Action(SelectGoods)
  selectGoods(ctx: StateContext<StorageLocationStateModel>, { goods }: SelectGoods): void {
    ctx.patchState({
      currentItem: goods
    });
  }

  @Action(CreateStorageItem)
  createStorageItem(ctx: StateContext<StorageLocationStateModel>, { item }: CreateStorageItem): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.createStorageItem(item)
      .subscribe({
        next: (createdItem) => ctx.dispatch(new CreateStorageItemSuccess(createdItem)),
        error: (error) => ctx.dispatch(new CreateStorageItemFail(error))
      });
  }

  @Action(CreateStorageItemSuccess)
  createStorageItemSuccess(ctx: StateContext<StorageLocationStateModel>, { item }: CreateStorageItemSuccess): void {
    const goods = cloneDeep(ctx.getState().goods);
    goods.push(item);
    ctx.patchState({
      goods,
      loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(CreateStorageItemFail)
  createStorageItemFail(ctx: StateContext<StorageLocationStateModel>, { error }: CreateStorageItemFail): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
    });
    this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося створити позицію' });
    console.error('`CreateStorageItemFail`: Не вдалося створити позицію', error);
  }

  @Action(UpdateStorageItem)
  updateStorageItem(ctx: StateContext<StorageLocationStateModel>, { id, item }: UpdateStorageItem): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.updateStorageItem(id, item)
      .subscribe({
        next: (updatedItem) => ctx.dispatch(new UpdateStorageItemSuccess(updatedItem)),
        error: (error) => ctx.dispatch(new UpdateStorageItemFail(error))
      });
  }

  @Action(UpdateStorageItemSuccess)
  updateStorageItemSuccess(ctx: StateContext<StorageLocationStateModel>, { item }: UpdateStorageItemSuccess): void {
    const goods = cloneDeep(ctx.getState().goods);
    const index = goods.findIndex(good => good.id === item.id);
    if (index !== -1) {
      goods[index] = item;
    }
    ctx.patchState({
      goods,
      loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(UpdateStorageItemFail)
  updateStorageItemFail(ctx: StateContext<StorageLocationStateModel>, { error }: UpdateStorageItemFail): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
    });
    this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося оновити позицію' });
    console.error('`UpdateStorageItemFail`: Не вдалося оновити позицію', error);
  }

  @Action(MoveStorageItem)
  moveStorageItem(ctx: StateContext<StorageLocationStateModel>, { data }: MoveStorageItem): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.moveItems(data)
      .subscribe({
        next: (storageLocations) => ctx.dispatch(new MoveStorageItemSuccess(storageLocations)),
        error: (error) => ctx.dispatch(new MoveStorageItemFail(error))
      });
  }

  @Action(MoveStorageItemSuccess)
  moveStorageItemSuccess(ctx: StateContext<StorageLocationStateModel>, { data }: MoveStorageItemSuccess): void {
    ctx.patchState({
      storageLocations: data,
      loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(MoveStorageItemFail)
  moveStorageItemFail(ctx: StateContext<StorageLocationStateModel>, { error }: MoveStorageItemFail): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
    });
    this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося перемістити позицію' });
    console.error('`MoveStorageItemFail`: Не вдалося перемістити позицію', error);
  }


  @Action(CreateStorageLocation)
  createStorageLocation(ctx: StateContext<StorageLocationStateModel>, { item }: CreateStorageLocation): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.createStorageLocation(item)
      .subscribe({
        next: (createdItem) => ctx.dispatch(new CreateStorageLocationSuccess(createdItem)),
        error: (error) => ctx.dispatch(new CreateStorageLocationFail(error))
      });
  }

  @Action(CreateStorageLocationSuccess)
  createStorageLocationSuccess(ctx: StateContext<StorageLocationStateModel>, { item }: CreateStorageLocationSuccess): void {
    const storageLocations = cloneDeep(ctx.getState().storageLocations);
    storageLocations.childrenFolders.push(item);
    ctx.patchState({
      storageLocations,
      loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(CreateStorageLocationFail)
  createStorageLocationFail(ctx: StateContext<StorageLocationStateModel>, { error }: CreateStorageLocationFail): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
    });
    this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося створити директорію' });
    console.error('`CreateStorageLocationFail`: Не вдалося створити директорію', error);
  }

  @Action(UpdateStorageLocation)
  updateStorageLocation(ctx: StateContext<StorageLocationStateModel>, { id, item }: UpdateStorageLocation): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.updateStorageLocation(id, item)
      .subscribe({
        next: (updatedItem) => ctx.dispatch(new UpdateStorageLocationSuccess(updatedItem)),
        error: (error) => ctx.dispatch(new UpdateStorageLocationFail(error))
      });
  }

  @Action(UpdateStorageLocationSuccess)
  updateStorageLocationSuccess(ctx: StateContext<StorageLocationStateModel>, { item }: UpdateStorageLocationSuccess): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.SUCCESS
    })
  }

  @Action(UpdateStorageLocationFail)
  updateStorageLocationFail(ctx: StateContext<StorageLocationStateModel>, { error }: UpdateStorageLocationFail): void {
    ctx.patchState({
      loadStorageLocationsStatus: PROGRESS_STATUSES.FAIL
    });
    this.toastService.createErrorToast({ label: 'Помилка', message: 'Не вдалося оновити директорію' });
    console.error('`UpdateStorageLocationFail`: Не вдалося оновити директорію', error);
  }
}


